import $ from 'jquery';
import EmblaCarousel from 'embla-carousel';
import { setupPrevNextBtns, listenForPrevBtnClick, listenForNextBtnClick, disablePrevNextBtns } from '../utils/PrevNextButtons.js';
import { resizeScroll } from '../core/ScrollService.js';
import { isTouchDevice } from '../utils/WindowUtils.js';
const initChainedFlow = () => {
    const checkSlides = () => {
        const width = window.innerWidth;

        if (width <= 767) {
            return 2;
        } else if (width > 767 && width <= 930) {
            return 4;
        } else {
            return 6;
        }
    }
    if (document.querySelectorAll('.pSection--chainedFlow')) {
        document.querySelectorAll('.pSection--chainedFlow').forEach((domElt) => {
            let domEmbla = domElt.querySelector('.embla');
            let slides = domElt.querySelectorAll('.embla__slide');
            let container = domElt.querySelector('.embla__container');
            let domEmblaPrev = domElt.querySelector('.chainedFlow_nav_prev');
            let domEmblaNext = domElt.querySelector('.chainedFlow_nav_next');
            let loop = domEmbla.getAttribute('data-loop') && domEmbla.getAttribute('data-loop') === "true";
            let dragFree = domEmbla.getAttribute('data-dragfree') && domEmbla.getAttribute('data-dragfree') === "true";
            let domEmblaOptions = { align: "center", active: checkSlides() < slides.length, loop: loop, dragFree: dragFree, draggable: isTouchDevice(), containScroll: 'trimSnaps' };
            let domEmblaPlugins = [];
            if (checkSlides() > slides.length) {
                container.style.justifyContent = 'center'
            }
            let embla = EmblaCarousel(domEmbla, domEmblaOptions, domEmblaPlugins);
            setupPrevNextBtns(domEmblaPrev, domEmblaNext, embla);
            embla.on("select", disablePrevNextBtns);
            embla.on("init", disablePrevNextBtns);
            embla.on("init", () => { resizeScroll(); });
        })
    }
};

export { initChainedFlow };
